import React, { useEffect, useState } from 'react'
import { Space } from 'antd'
import Collapse from 'antd/lib/collapse'
import { MenuNode } from './MenuNode'
import { SolidLineIcon } from './nodes'
import { BasicNode, BasicShape } from './BasicNode'
import { FlowEquipmentMenu, getFlowMenus } from '@/services/admin/equipment-menu/equipmentMenu.services'

const { Panel } = Collapse

export const LeftMenu = () => {
  const [menus, setMenus] = useState<FlowEquipmentMenu[]>([])
  useEffect(() => {
    getFlowMenus().then(data => {
      setMenus(data)
    })
  }, [])

  return <Collapse>
    <Panel header="Basic" key='basic'>
        <Space wrap size={20}>
          <BasicNode
            type={BasicShape.Stream}
            component={<SolidLineIcon style={{width: '100%'}} />} title={'Stream'}/>
        </Space>
    </Panel>
    {menus.map(menu => {
      return <Panel header={menu.name} key={menu.id}>
      <Space wrap size={20}>
        {menu.equipment.map(item => {
          return <MenuNode key={item.id} equipment={item}/>
        })}
      </Space>
    </Panel>
    })}
  </Collapse>
}